import React, { useMemo } from "react";
import { Avatar } from "@mui/material";

interface CommentAvatarProps {
  first_name?: string;
  user_id?: number;
}

const CommentAvatar: React.FC<CommentAvatarProps> = ({
  first_name,
  user_id,
}) => {
  const bg = useMemo(() => {
    // Generate a random pastel color once per component instance
    const hue = Math.floor(Math.random() * 360);

    return `hsl(${hue}, 60%, 70%)`;
  }, []);

  return (
    <Avatar sx={{ bgcolor: bg, color: "#000" }}>
      {first_name?.[0]?.toUpperCase() ?? "G"}
    </Avatar>
  );
};

export default CommentAvatar;
